import * as Types from '../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type JobsAllVariationsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.JobFilterInput>;
}>;


export type JobsAllVariationsQuery = { __typename: 'Query', jobs: Array<{ __typename: 'Job', id: string } | null> };

export const JobsAllVariationsDocument = gql`
    query jobsAllVariations($filter: JobFilterInput) {
  jobs(filter: $filter) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class JobsAllVariationsGQL extends Apollo.Query<JobsAllVariationsQuery, JobsAllVariationsQueryVariables> {
    override document = JobsAllVariationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }